/** * 主界面中心组件 * 创建时间：2017-02-22 * 创建人：zhanlz */
<template>
	<div>
		<!-- 车辆监控页面_左侧车辆列表模块开始  -->
		<div class="tab-vertical-left tab-vertical">
			<div class="tab-title">
				<div class="dropdown">
					<a id="dLabel" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i></i> </a>
					<ul class="dropdown-menu list-group" id="menuL" aria-labelledby="dLabel">
						<li class="list-group-item">主面板</li>
						<li class="list-group-item">在线</li>
						<li class="list-group-item">离线</li>
						<li class="list-group-item">未定位</li>
						<li class="list-group-item">行驶中</li>
						<li class="list-group-item">停车中</li>
						<li class="list-group-item">停车超时</li>
						<li class="list-group-item">当日超速</li>
						<li class="list-group-item">紧急报警</li>
						<li class="list-group-item">紧急报警2</li>
					</ul>
				</div>
				<span>主面板</span> <em></em> </div>
			<div class="tab-header">
				<div id="btnUpL" class="btn1"> </div>
				<div class="tabs">
					<div class="innerTabs">
						<div class="tab-item active"><span>主面板</span></div>
						<div class="tab-item"><span>在线</span></div>
						<div class="tab-item"><span>离线</span></div>
						<div class="tab-item"><span>未定位</span></div>
						<div class="tab-item"><span>行驶中</span></div>
						<div class="tab-item"><span>停车中</span></div>
						<div class="tab-item"><span>停车超时</span></div>
						<div class="tab-item"><span>当日超速</span></div>
						<div class="tab-item"><span>紧急报警</span></div>
						<div class="tab-item"><span>紧急报警2</span></div>
					</div>
				</div>
				<div id="btnDownL" class="btn2"> </div>
			</div>
			<div class="tab-body">
				<div class="tab-content" id="myWeek">
					<div class="tab-bar">
						<div class="tab-row">
						<!--	<tree :tree-data="tree1" 
								:showAppend="false" 
								:showCheckbox="true"
								:showRemove="false"  
								@append="onAppend" 
								@click="onClick">
							</tree>-->
						</div>
						<div class="tab-row">在线</div>
						<div class="tab-row">离线</div>
						<div class="tab-row">未定位</div>
						<div class="tab-row">行驶中</div>
						<div class="tab-row">停车中</div>
						<div class="tab-row">停车超时</div>
						<div class="tab-row">当日超速</div>
						<div class="tab-row">紧急报警</div>
						<div class="tab-row">紧急报警2</div>
					</div>
				</div>
			</div>
			
		</div>
		<!-- 车辆监控页面_左侧车辆列表模块结束  -->
		
		<!--<tree-node v-for="(node,index) in tree1"  :key="index"
    		ref="treenode"
    		:node="node"
    		:showCheckbox="true"
    		:index="index"
    		:showAppend="true"
    		:showRemove="true"
    		@click="handleClick"
    		@append="onAppend"
    		@remove="onRemove"
    		@check="handleCheck">
    	</tree-node>-->
		<progress-bar></progress-bar>
		<monitor-map></monitor-map>
		<button @click="test" style="position: absolute;top: 20px;right: 30px;">增加1000叶子节点</button>
		<button @click="test11" style="position: absolute;top: 40px;right: 30px;">每个组织机构增加1000叶子节点</button>
		<button @click="test12" style="position: absolute;top: 70px;right: 30px;">增加10个组织机构，每个组织机构有1000个点</button>
	</div>

</template>

<script>
	//import Tree from "../common/Tree/Tree"
	import TreeNode from "../common/Tree/TreeNode"
	import ProgressBar from "../common/ProgressBar"
	import MonitorMap from "../common/Map/MonitorMap"
	export default {
		name: 'PageStatistic',
		components: {
		//	Tree,
			TreeNode,
			ProgressBar,
			MonitorMap
		},
		data() {
			return {
				tree1: []
			};
		},
		mounted() {
			this.$http.get('../../../static/treedata.json')
				.then((response) => {
					console.log(response.data);
					var treeTmp = response.data;
					var start = new Date().getTime();
					//					var fakeData = this.fakeData();
					var tree = this.listToTree(treeTmp, {
						idKey: 'id',
						parentKey: 'parentId',
						childrenKey: 'children'
					})

					this.$set(this, "tree1", tree);
					var end = new Date().getTime();
					console.log(end - start);
				})
		},
		methods: {
			/**
			 * 增加子节点时钩子
			 * 参数1：当前结点
			 * 参数2：true:要增加叶子结点;false:要增加分组节点
			 */
			onAppend(obj, isLeaf) {
				if(isLeaf) {
					obj.children.push({
						text: '15000009',
						isLeaf: true,
						children: []
					})
				} else {
					obj.children.push({
						text: '测试分组',
						isLeaf: false,
						children: []
					})
				}
			},
			/**
			 * 点击节点时钩子
			 * 参数1：当前结点
			 */
			onClick(obj) {
				console.log(obj.text);
			},
			test(){
				var fakeData = [];
				for(let i = 0;i<1000;i++){
					fakeData.push({
						id:10000+i,
						text:'15' + i,
						isLeaf: true,
						state: 'run',
						name: '张晓明',
						type: 3
					})
				}
//				this.tree1[0].children.push(fakeData);
				this.tree1[0].children = this.tree1[0].children.concat(fakeData);
			},
			// 每个节点增加1000叶子
			test1(node){
				if(node.isLeaf) return;
				else {
					var fakeData = [];
					for(let i = 0;i<1000;i++){
						fakeData.push({
							id:10000+i,
							text:'15' + i,
							isLeaf: true,
							state: 'run',
							name: '张晓明',
							type: 3
						})
					}
	//				this.tree1[0].children.push(fakeData);
					if(!node.children) return;
					node.children = node.children.concat(fakeData);
					node.children.forEach( child => {
						this.test1(child);
					})
				}
			},
			test11(){
				this.tree1.forEach(node => {
					this.test1(node);
				});
			},
			test12(){
				for(let i = 0;i<10;i++){
					var node1 = {
						id: 1,
						text: "广东启明兴达",
						parentId: 0,
						type: 1,
						children: []
					}
					var fakeData = [];
					for(let i = 0;i<1000;i++){
						fakeData.push({
							id:10000+i,
							text:'15' + i,
							isLeaf: true,
							state: 'run',
							name: '张晓明',
							type: 3
						})
					}
					node1.children = fakeData;
					this.tree1.push(node1);
				}
			},
			listToTree(data, options) {
				options = options || {};
				var ID_KEY = options.idKey || 'id';
				var PARENT_KEY = options.parentKey || 'parent';
				var CHILDREN_KEY = options.childrenKey || 'children';

				var tree = [],
					childrenOf = {};
				var item, id, parentId;

				for(var i = 0, length = data.length; i < length; i++) {
					item = data[i];
					id = item[ID_KEY];
					parentId = item[PARENT_KEY] || 0;
					// every item may have children
					childrenOf[id] = childrenOf[id] || [];
					// init its children
					item[CHILDREN_KEY] = childrenOf[id];
					if(parentId != 0) {
						// init its parent's children object
						childrenOf[parentId] = childrenOf[parentId] || [];
						// push it into its parent's children object
						childrenOf[parentId].push(item);
					} else {
						tree.push(item);
					}
				};
				return tree;
			}
		}
	};
</script>


// WEBPACK FOOTER //
// PageStatistic.vue?34429a34